// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b82c14f9","696":"6ac289a4","961":"14062b07"}[chunkId] + ".chunk.js";
};